export default __webpack_public_path__ + "static/media/btn_big_new.1bcd69e9.svg";